import { Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ArrowLeft2, ArrowRight2, ShopAdd } from "iconsax-react";
import { useTranslation } from "react-i18next";

import { SefanoButton } from "@/components/Molecules/SefanoButton";
import type { CreateShopWizardNavProps } from "./CreateShopWizardNav.types";
import * as styles from "./CreateShopWizardNav.styles";

export type { CreateShopWizardNavProps } from "./CreateShopWizardNav.types";

export function CreateShopWizardNav({
  mobile = false,
  isLastStep,
  showBack,
  nextDisabled,
  isSubmitting,
  onNext,
  onBack,
  onFinish,
}: CreateShopWizardNavProps) {
  const { t } = useTranslation("shops");
  const theme = useTheme();

  const finishLabel = mobile ? "create.nav.createMobile" : "create.nav.create";

  return (
    <Box sx={styles.root}>
      {showBack ? (
        <Button
          variant={mobile ? "outlined" : "text"}
          color="primary"
          onClick={onBack}
          sx={styles.text}
        >
          {mobile ? (
            t("create.nav.backMobile")
          ) : (
            <Box component="span" sx={styles.nav}>
              <ArrowRight2 size={18} variant="Linear" />
              {t("create.nav.back")}
            </Box>
          )}
        </Button>
      ) : (
        <Box sx={styles.spacer} />
      )}

      {!isLastStep ? (
        <SefanoButton
          onClick={onNext}
          disabled={nextDisabled || isSubmitting}
          fullWidth={mobile}
          sx={styles.contained}
          endIcon={<ArrowLeft2 size={18} variant="Linear" color={theme.palette.primary.contrastText} />}
        >
          {t("create.nav.next")}
        </SefanoButton>
      ) : null}

      {isLastStep ? (
        <SefanoButton
          onClick={onFinish}
          disabled={isSubmitting}
          fullWidth={mobile}
          sx={styles.finish(mobile)}
          startIcon={<ShopAdd size={18} variant="Bold" color={theme.palette.primary.contrastText} />}
        >
          {isSubmitting ? t("create.nav.submitting") : t(finishLabel)}
        </SefanoButton>
      ) : null}
    </Box>
  );
}
